import axios from 'axios';

import cfac22 from '../cfac22';

export function getSeuClube(uId, clubeId) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      get(cfac22('API_HOST_V2') + '/seuClube/getSeuClube?clubeId=' + clubeId, {
        headers: { 'Full-Url': window.location.href }, withCredentials: true
      }).
      then((result) => {
        // console.log("RESULTADO SEU CLUBE ==>", result.data.result);
        resolve(result.data.result);
        sessionStorage.setItem('seuClubeInfos', JSON.stringify(result.data.result));
      }).
      catch((error) => {
        // console.log('ERRO SEU CLUBE ==>', error);
        return reject(error.response.data);
      });
    }).
    catch((error) => {
      reject(error);
    });
  });
}
